import React, {useState} from 'react'
import AxiosURL from '../../ApiService/AxiosURL';
import './auth.css'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import {toast, ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

 function Login() {
    // const {http, setToken} = AuthUser();
    const [email, setEmail] = useState();
    const [password, setPassword] = useState();
    const [useErrorEmptyMsg, setErrorEmptyMsg] = useState();
    const [useErrorEmptypasswordMsg, setErrorEmptypasswordMsg] = useState();
    const navigate = useNavigate();
    const [useError, setError] = useState([]);
    
    const handleSubmit = e => { 
        e.preventDefault()
        if(email=='')
                {
                    setErrorEmptyMsg("This field is required");
                }
                else if(password=='')
                {
                    setErrorEmptypasswordMsg("This field is required");
                }
                else{
                    // call API
            AxiosURL
          .post("/login", { email, password })
          .then(response => {
            localStorage.setItem('token',JSON.stringify(response.data.data.token));
            localStorage.setItem('userName',JSON.stringify(response.data.data.name));
            localStorage.setItem('message',JSON.stringify(response.data.message));
            localStorage.setItem('role_id',JSON.stringify(response.data.data.role_id));
            let token = localStorage.getItem('token');
            let role_id = localStorage.getItem('role_id');
            // toast.success("Successgully loggedIn", {position: toast.POSITION.TOP_CENTER});
            if(token && role_id==2){
                navigate('/farmer_profile');                
            }
            if(token && role_id==3){
                navigate('/mill-dashboard');                
            }
          }).catch((error) => {
            if (error.response) {
                setError((error.response.data.message));
                toast.error("something went wrong", {position: toast.POSITION.TOP_CENTER});
            } else if (error.request) {
                console.log("err kk")
            } else {
            }
        });
        }
      }
   
  return (
    <section  className='login_page'  style={{ backgroundImage: "url('images/castor seeds.png')" }}>
    <div className='container-fluid p-5 mainLoginDiv'>
        <div className='row '>
            <div className='col col-sm-6 offset-sm-3'>
                <ToastContainer/>
                <div className='login_card'  style={{ opacity: "%",  filter: "blur(35%)", fill: "brown"}}>
                    <div className='login' >
                        <div className='loghead'>                      
                        <form action="" id="login" method="post" onSubmit={handleSubmit}>
                        <div className='row p-5'>
                            <div className='col col-sm-12'>
                        <input type="text" className="form-control"  placeholder="Enter email id" 
                                    onChange={e=>setEmail(e.target.value)}
                                    id="farmer_code_id" name="email" value={email}/>
                            </div>
                            <b style={{color:"red",size:"30px"}}>{useErrorEmptyMsg}</b>
                            
                            <div className='col col-sm-12'>
                        <input type="password" className="form-control" placeholder="Enter password" 
                                    onChange={e=>setPassword(e.target.value)}
                                      id="password_id" name="password"  value={password}/>
                            </div>
                            <b style={{color:"red",size:"30px"}}>{useErrorEmptypasswordMsg}</b>
                            <b style={{color:"red",size:"30px", fontSize:'1.5rem'}}>{useError}</b>
                            <br /><br />
                            {/* <input value='Login' className='btn btn-secondary svbtn' onClick={submitLoginForm} id="btn_id"/> */}
                            <input value='Login' type="submit" className=' btn-secondary svbtn'  id="btn_id"/>
                           </div>
                        </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </section>
  )
}
export default Login;